import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Brand } from "../components/Brand";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register, loading } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ nome: "", cognome: "", email: "", password: "", telefono: "" });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await register(form);
      toast.success("Account creato!");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registrazione fallita");
    }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center p-8 bg-[#050505] order-2 lg:order-1">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
          <Link to="/"><Brand /></Link>
          <h1 className="font-display text-3xl font-extrabold uppercase mt-10 tracking-tight">Crea Account</h1>
          <p className="text-sm text-white/45 mt-2">Inizia a gestire la tua flotta in pochi secondi.</p>
          <form onSubmit={submit} className="mt-8 space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <input data-testid="reg-nome" required placeholder="Nome" value={form.nome} onChange={upd("nome")}
                className="bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm focus:border-[#ff0033]/60 focus:outline-none" />
              <input data-testid="reg-cognome" required placeholder="Cognome" value={form.cognome} onChange={upd("cognome")}
                className="bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm focus:border-[#ff0033]/60 focus:outline-none" />
            </div>
            <input data-testid="reg-email" required type="email" placeholder="Email" value={form.email} onChange={upd("email")}
              className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm focus:border-[#ff0033]/60 focus:outline-none" />
            <input data-testid="reg-telefono" placeholder="Telefono" value={form.telefono} onChange={upd("telefono")}
              className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm focus:border-[#ff0033]/60 focus:outline-none" />
            <input data-testid="reg-password" required type="password" placeholder="Password" value={form.password} onChange={upd("password")}
              className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm focus:border-[#ff0033]/60 focus:outline-none" />
            <button data-testid="reg-submit" disabled={loading} className="btn-neon w-full py-3.5 rounded-xl text-sm mt-2">
              {loading ? "Creazione..." : "Crea Account"}
            </button>
          </form>
          <div className="mt-6 text-xs text-white/40 text-center">
            Hai già un account? <Link to="/login" className="text-[#ff0033] hover:underline">Accedi</Link>
          </div>
        </motion.div>
      </div>
      <div className="hidden lg:block relative overflow-hidden order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1655772931336-a1d0846a9d8a?w=1400&q=80" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-l from-black/95 via-black/60 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-right">
          <div className="font-display text-5xl font-black tracking-tighter uppercase leading-[0.95]">
            Inizia<br /><span className="neon-text">l'accelerazione.</span>
          </div>
          <p className="mt-4 text-white/55 max-w-md ml-auto">Tutti i tool per portare il tuo noleggio nel 2026.</p>
        </div>
      </div>
    </div>
  );
}
